/*jslint browser: true */

"use strict";

var $ = require("pli/jquery");
var pli = require("pli/core");
var reloadPageIfObsolete = require("pli/util/reloadPageIfObsolete");

var $logon = $("#login_action_submit"),
    $name = $("#NameValue"),
    $pswd = $("#PswdValue"),
    $pswdLabel = $("#PswdLabel"),
    $mail = $("#MailValue"),
    $message = $("#Message"),
    $info = $("#Info"),
    $recovery = $("#Recovery"),
    $formTitle = $("#FormTitle"),
    $uiElements = $name.add($("#NameLabel")).add($pswd).add($pswdLabel).add($mail).add($recovery),
    emptyTest = /^\s*$/,
    logonTexts = $("form").data("pliLogonTexts"),
    state,
    currentCall;

//-------------------------------------------
function findFocus(errorClass, $ignore) {
    /// <summary>
    /// Find first empty input control (optionally
    /// ignoring the specified $ignore control).
    /// If errorClass is specified, all controls
    /// that are empty will have this class added
    /// to their class attribute.
    /// </summary>
    var $toFocus = null, test;

    if ($ignore !== $name) {
        test = emptyTest.test($name[0].value);
        if (errorClass) {
            $name.toggleClass(errorClass, test);
        }
        $toFocus = $toFocus || (test ? $name : null);
    }

    if ($ignore !== $pswd) {
        test = emptyTest.test($pswd[0].value);
        if (errorClass) {
            $pswd.toggleClass(errorClass, test);
        }
        $toFocus = $toFocus || (test ? $pswd : null);
    }

    if ($ignore !== $mail) {
        test = emptyTest.test($mail[0].value);
        if (errorClass) {
            $mail.toggleClass(errorClass, test);
        }
        $toFocus = $toFocus || (test ? $mail : null);
    }

    return $toFocus;
}


//-------------------------------------------
function setState(newState, errorMessage) {
    /// <summary>
    /// Update UI state to reflect specified state
    /// and update the "state" variable.
    /// </summary>

    switch (newState) {
    case "recoveryReady":
        $formTitle.text(logonTexts.RecoveryTitle);
        $info.html(logonTexts.RecoveryHelpReady).removeClass("error").fadeIn();
        $recovery.html(logonTexts.RecoveryLinkDeactivate);
        $pswdLabel.text(logonTexts.EmailLabel);
        $message.addClass("error").text(errorMessage || "");
        $logon.find("span").text(logonTexts.RecoverySubmitLabel);
        $pswd.attr("value", "").hide();
        $mail.show();
        $uiElements.prop("disabled", false).removeClass("disabled error");
        (findFocus(null, $pswd) || $mail).focus();
        break;

    case "recoveryFinished":
        $message.text("");
        $info.html(logonTexts.RecoveryHelpSuccess).removeClass("error").fadeIn();
        $logon.find("span").text(logonTexts.RecoveryBackLabel);
        $recovery.prop("disabled", false).removeClass("disabled");
        break;

    case "logonReady":
        $formTitle.text(logonTexts.LogOnTitle);
        $info.stop(true, true).hide();
        $recovery.html(logonTexts.RecoveryLinkActivate);
        $pswdLabel.text(logonTexts.PasswordLabel);
        $message.addClass("error").text(errorMessage || "");
        $logon.find("span").text(logonTexts.LogOnSubmitLabel);
        $pswd.show();
        $mail.hide();
        $uiElements.prop("disabled", false).removeClass("disabled error");
        (findFocus(null, $mail) || $pswd).focus();
        break;

    case "init":
    case "recovery":
    case "logon":
        $uiElements.prop("disabled", true).addClass("disabled");
        if (!$logon.prop("disabled")) { $logon.focus(); }
        $logon.find("span").text(logonTexts.CancelLabel);
        $info.stop(true, true).hide();
        $message.removeClass("error").text(newState === "init" ? logonTexts.InitInProgress : newState === "logon" ? logonTexts.LogOnInProgress : logonTexts.RecoveryInProgress).show();
        break;
    }

    state = newState;
}


//-------------------------------------------
function callFailed(response) {
    /// <summary></summary>
    if (response.clientStatus !== "abort") { // ignore failures caused by currentCall.xhr.abort() (see function "onSubmit" for details on when abort is being used)

        if (window.console && typeof window.console.error === "function") {
            window.console.error("Pli call error: ".concat((response.result.exception && response.result.exception.message) || response.result.message), response);
        }

        if (state === "recovery") {
            setState("recoveryReady", logonTexts.RecoveryFailed);
            $info.html(logonTexts.RecoveryHelpFailure).addClass("error").fadeIn();
        } else {
            setState("logonReady", logonTexts.LogOnFailed);
            $info.html(logonTexts.LogOnHelpFailure).addClass("error").fadeIn();
        }
    }
    currentCall = null;
}


//-------------------------------------------
function callSucceeded(response) {
    /// <summary>
    /// </summary>
    if (state === "recovery") {
        setState("recoveryFinished");
    } else {
        $logon.prop("disabled", true).addClass("disabled");
        location.replace(response.result.url);
    }
    currentCall = null;
    return null;
}


//-------------------------------------------
function onSubmit(event) {
    /// <summary>
    /// </summary>
    var $toFocus, logon = false;

    event.preventDefault();

    switch (state) {
    case "init":
        throw new Error("Submit can't be called during form initialization");

    case "logon": // cancel ongoing logon
        currentCall.xhr.abort();
        setState("logonReady");
        return;

    case "recovery": // cancel ongoing recovery
        currentCall.xhr.abort();
        setState("recoveryReady");
        return;

    case "recoveryFinished":
        setState("logonReady");
        return;

    case "logonReady":
        logon = true;
        break;

    case "recoveryReady":
        break;
    }

    $toFocus = findFocus("error", logon ? $mail : $pswd);
    if ($toFocus) {
        $message.addClass("error").text(logonTexts.ErrorEmptyFields).show();
        $toFocus.focus();
    } else {
        setState(logon ? "logon" : "recovery");
        currentCall = pli.call({
            name: logon ? "Pli-Authentication-LogOn" : "Pli-Authentication-ResetPassword",
            ignoreUnauthenticated: true,
            data: { name: $name[0].value, pswd: $pswd[0].value, mail: $mail[0].value }
        }).then(callSucceeded, callFailed);
    }
}


//-------------------------------------------
function onFormClick(event) {
    var $anchor = $(event.target).closest("a"), command = $anchor.attr("href"), separator;
    if (command) {
        separator = command.indexOf("#");
        if (separator >= 0) {
            command = command.slice(separator + 1);
            switch (command) {
            case "userName":
                event.preventDefault();
                $name.focus();
                break;
            case "email":
                event.preventDefault();
                $mail.focus();
                break;
            case "recover":
                event.preventDefault();
                setState(state === "recoveryReady" || state === "recoveryFinished" ? "logonReady" : "recoveryReady");
                break;
            case "submit":
                onSubmit(event); // will call event.preventDefault()
                break;
            }
        }
    }
}


//-------------------------------------------
function selectText(event) {
    /// <summary>
    /// Select all the text in the event target.
    /// </summary>
    event.target.select();
}


$("form").submit(onSubmit).click(onFormClick);
$name.focus(selectText); // add focus event handler that will also select the text in that field
$pswd.focus(selectText);
$mail.focus(selectText);

setState("init");
pli.call({ name: "Pli-Authentication-LogOnFormInit" }).then(
    function logonFormLoaded(response) {
        if (reloadPageIfObsolete(response)) { return; }
        $logon.prop("disabled", false).closest("li").removeClass("disabled");
        setState("logonReady");
    },
    function logonFormFailedToLoad() {
        $message.addClass("error").text("Initialization failed");
    }
);



//////////////////
// WEBPACK FOOTER
// ./app/logon/logOn.js
// module id = 734
// module chunks = 18